import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  projectSearchInfo: {
    compId: '',
    projName: '',
    projStatus: '',
    status: ''
  },
  projStatusList: [],
  projectListObject: {
    projectList: [],
    currentPage: 1,
    pageSize: 10,
    total: 0,
    totalPage: 0
  },
  projectInfo: {
    projId: '',
    projName: '',
    projDesc: '',
    compId: '',
    projSettleDtNum: 0,
    defSurchargeTaxRate: 0,
    projectPercent: 0,
    projMgr: '',
    projStatus: '',
    startDt: new Date(),
    endDt: new Date(),
    accountant: '',
    // accountantOn: new Date(),
    cashier: '',
    // cashierOn: new Date(),
    status: '',
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0),
    //
    indUsed: ''
  },
  compProjDDList: [],
  projPositionDDList: [],
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertProject({
    dispatch,
    commit,
    state
  }, {accountant, cashier, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_RSP_PROJECT, {
      data: {
        projName: state.projectInfo.projName,
        projDesc: state.projectInfo.projDesc,
        compId: state.projectInfo.compId,
        projSettleDtNum: state.projectInfo.projSettleDtNum,
        defSurchargeTaxRate: state.projectInfo.defSurchargeTaxRate,
        projectPercent: state.projectInfo.projectPercent,
        projStatus: state.projectInfo.projStatus,
        startDt: state.projectInfo.startDt,
        accountant: accountant,
        cashier: cashier,
        // assignOn: state.projectInfo.assignOn,
        status: state.projectInfo.status,
        projId: '' // 没有这个就会报服务端错误
      },
      headerMap: await getCPHeaderMap(state.projectInfo.compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateProject({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    let projectInfo = {
      projName: state.projectInfo.projName,
      projDesc: state.projectInfo.projDesc,
      projStatus: state.projectInfo.projStatus,
      startDt: state.projectInfo.startDt,
      endDt: state.projectInfo.endDt,
      // assignTo: state.projectInfo.assignTo,
      // assignOn: state.projectInfo.assignOn,
      status: state.projectInfo.status,
      //
      key: {
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJECT, {
      data: projectInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeProject({
    commit,
    state
  }, {projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_PROJECT + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async findProject({
    commit
  }, {projId, compId, codeParam}) {
    const responseData = await getReq(END_POINTS.FIND_RSP_PROJECT + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    if (responseData.success) {
      commit('updateProjectInfo', responseData.data)
    } else {
      commit('updateProjectInfo', {})
    }
  },
  async findProjectCondition({
    commit,
    state,
    rootState
  }, { currentPage, pageSize, codeParam }) {
    let stateCurrentPage = currentPage
    if (pageSize) {
      state.projectListObject.pageSize = pageSize
      stateCurrentPage = 1
    }
    // debugger
    // console.log(typeof getCPHeaderMap)
    const projectListObject = await postReq(END_POINTS.FIND_RSP_PROJECT_CONDITION, {
      data: {
        currentPage: stateCurrentPage,
        orderBy: '',
        pageSize: state.projectListObject.pageSize,
        queryVO: {
          compId: state.projectSearchInfo.compId,
          projName: state.projectSearchInfo.projName,
          projStatus: state.projectSearchInfo.projStatus,
          status: state.projectSearchInfo.status
        },
        refreshTotalRecord: true
      },
      headerMap: await getCPHeaderMap(state.projectSearchInfo.compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjectListObject', projectListObject)
  },
  async updateProjectMgr({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    let projectInfo = {
      projMgr: state.projectInfo.projMgr,
      //
      key: {
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJECT_MGR, {
      data: projectInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async updateProjSettleDtNumber({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    let projectInfo = {
      projSettleDtNum: state.projectInfo.projSettleDtNum,
      //
      key: {
        projId: projId,
        compId: compId
      }
    }
    // debugger
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJECT_SETTLE_DT_NUM, {
      data: projectInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async updateProjDefSurchargeTaxRate({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    let projectInfo = {
      defSurchargeTaxRate: state.projectInfo.defSurchargeTaxRate,
      //
      key: {
        projId: projId,
        compId: compId
      }
    }
    // debugger
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_DEF_SURCHARGE_TAX_RATE, {
      data: projectInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async updateProjectPercent({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    let projectInfo = {
      projectPercent: state.projectInfo.projectPercent,
      //
      key: {
        projId: projId,
        compId: compId
      }
    }
    // debugger
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJECT_PERCENT, {
      data: projectInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async buildProject({
    commit
  }, {projId, compId, codeParam}) {
    const responseData = await getReq(END_POINTS.BUILD_PROJECT + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return responseData
  },
  async buildDemoProject({
    commit
  }, {projId, compId, codeParam}) {
    const responseData = await getReq(END_POINTS.BUILD_DEMO_PROJECT + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return responseData
  },
  async findCompProjDDList({
    commit,
    state,
    rootState
  }, { compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_COMP_PROJ_DD_LIST + `?compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateCompProjDDList', response)
  },
  async findProjPositionDDList({
    commit,
    state,
    rootState
  }, { codeParam }) {
    const response = await getReq(END_POINTS.FIND_PROJ_POSITION_DD_LIST, {
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjPositionDDList', response)
  },
  END_ACTIONS() {}
}

const mutations = {
  updateSearchCompId(state, value) {
    state.projectSearchInfo.compId = value
  },
  updateSearchProjName(state, value) {
    state.projectSearchInfo.projName = value
  },
  updateSearchProjStatus(state, value) {
    state.projectSearchInfo.projStatus = value
  },
  updateSearchStatus(state, value) {
    state.projectSearchInfo.status = value
  },
  //
  updateProjName(state, value) {
    state.projectInfo.projName = value
  },
  updateProjDesc(state, value) {
    state.projectInfo.projDesc = value
  },
  updateCompId(state, value) {
    state.projectInfo.compId = value
  },
  updateProjSettleDtNum(state, value) {
    state.projectInfo.projSettleDtNum = value
  },
  updateDefSurchargeTaxRate(state, value) {
    state.projectInfo.defSurchargeTaxRate = value
  },
  updateProjectPercent(state, value) {
    state.projectInfo.projectPercent = value
  },
  updateProjMgr(state, value) {
    state.projectInfo.projMgr = value
  },
  updateProjStatus(state, value) {
    state.projectInfo.projStatus = value
  },
  updateStartDt(state, value) {
    // debugger
    state.projectInfo.startDt = value
  },
  updateEndDt(state, value) {
    state.projectInfo.endDt = value
  },
  updateAccountant(state, value) {
    state.projectInfo.accountant = value
  },
  // updateAccountantOn(state, value) {
  //   state.projectInfo.accountantOn = value
  // },
  updateCashier(state, value) {
    state.projectInfo.cashier = value
  },
  // updateCashierOn(state, value) {
  //   state.projectInfo.cashierOn = value
  // },
  updateStatus(state, value) {
    state.projectInfo.status = value
  },
  updateProjectListObject(state, projectListObject) {
    if (projectListObject.code === 2001) {
      state.projectListObject.projectList = projectListObject.data
      // projectListObject.data.map(value => {
      //   return {
      //     projId: value.projId,
      //     projName: value.projName,
      //     projDesc: value.projDesc,
      //     compId: value.compId,
      //     projSettleDtNum: value.projSettleDtNum,
      //     defSurchargeTaxRate: value.defSurchargeTaxRate,
      //     projMgr: value.projMgr,
      //     projStatus: value.projStatus,
      //     startDt: value.startDt,
      //     endDt: value.endDt,
      //     // accountantTo: value.accountantTo,
      //     // accountantOn: value.accountantOn,
      //     // cashierTo: value.cashierTo,
      //     // cashierOn: value.cashierOn,
      //     status: value.status,
      //     lastDoneRptId: value.lastDoneRptId,
      //     lastDoneRptMth: value.lastDoneRptMth,
      //     lastDoneRptStatus: value.lastDoneRptStatus,
      //     lastUnDoneRptId: value.lastUnDoneRptId,
      //     lastUnDoneRptMth: value.lastUnDoneRptMth,
      //     lastUnDoneRptStatus: value.lastUnDoneRptStatus,
      //     crtBy: value.crtBy,
      //     crtOn: value.crtOn,
      //     updBy: value.updBy,
      //     updOn: value.updOn,
      //     //
      //     indUsed: value.indUsed
      //   }
      // })
      state.projectListObject.currentPage = projectListObject.currentPage
      state.projectListObject.pageSize = projectListObject.pageSize
      state.projectListObject.total = projectListObject.total
      state.projectListObject.totalPage = projectListObject.totalPage
    } else {
      state.projectListObject.projectList = []
      state.projectListObject.total = 0
    }
  },
  updateProjectEmpty(state) {
    state.projectInfo.projId = ''
    state.projectInfo.projName = ''
    state.projectInfo.projDesc = ''
    state.projectInfo.compId = ''
    state.projectInfo.projSettleDtNum = 0
    state.projectInfo.defSurchargeTaxRate = 0
    state.projectInfo.projectPercent = 0
    state.projectInfo.projMgr = ''
    state.projectInfo.projStatus = ''
    state.projectInfo.startDt = new Date()
    state.projectInfo.endDt = new Date()
    state.projectInfo.accountant = ''
    // state.projectInfo.accountantOn = new Date()
    state.projectInfo.cashier = ''
    // state.projectInfo.cashierOn = new Date()
    state.projectInfo.status = ''
    state.projectInfo.crtBy = ''
    state.projectInfo.crtOn = new Date(0)
    state.projectInfo.updBy = ''
    state.projectInfo.updOn = new Date(0)
    //
    state.projectInfo.indUsed = ''
  },
  updateProjectInfo(state, projectInfo) {
    // debugger
    // state.projectInfo.id = projectInfo.projId
    state.projectInfo.projName = projectInfo.projName
    state.projectInfo.projDesc = projectInfo.projDesc
    state.projectInfo.compId = projectInfo.compId
    state.projectInfo.projSettleDtNum = projectInfo.projSettleDtNum
    state.projectInfo.defSurchargeTaxRate = projectInfo.defSurchargeTaxRate
    state.projectInfo.projectPercent = projectInfo.projectPercent
    state.projectInfo.projMgr = projectInfo.projMgr
    state.projectInfo.projStatus = projectInfo.projStatus
    state.projectInfo.startDt = projectInfo.startDt
    state.projectInfo.endDt = projectInfo.endDt
    // state.projectInfo.accountantTo = projectInfo.accountantTo
    // state.projectInfo.accountantOn = projectInfo.accountantOn
    // state.projectInfo.cashierTo = projectInfo.cashierTo
    // state.projectInfo.cashierOn = projectInfo.cashierOn
    state.projectInfo.status = projectInfo.status
    state.projectInfo.crtBy = projectInfo.crtBy
    state.projectInfo.crtOn = projectInfo.crtOn
    state.projectInfo.updBy = projectInfo.updBy
    state.projectInfo.updOn = projectInfo.updOn
    //
    state.projectInfo.indUsed = projectInfo.indUsed
  },
  updateCompProjDDList(state, response) {
    if (response.success === true && response.data.length) {
      state.compProjDDList = Utils.toListWapper(response.data, {valueField: 'projId', descrField: 'projName'})
    } else {
      state.compProjDDList = []
    }
  },
  updateProjPositionDDList(state, response) {
    if (response.success === true && response.data.length) {
      state.projPositionDDList = response.data
    } else {
      state.projPositionDDList = []
    }
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/rspProjectManage.js